/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/17
 * Time: 09:38
 * Desc: 云店设置-黑名单
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils } from '@/util';
const isset = QinggerLibUtils.isset;

@Component
export default class GoodsCategoryBlackList extends Vue {
  /* 数据 */

  /**
   * 关联分类：下拉标签
   * @type {ItemArray<RelationClass>}
   */
  public connectedClass: ItemArray<RelationClass> = [];

  /**
   * 关联分类 标签选择限制
   * @type {number}
   */
  public limitNum = 6;

  /**
   * 关联分类：已选中的下拉标签
   * @type {ItemArray<RelationClass>}
   */
  public selectConnectedClass: ItemArray<RelationClass> = [];

  /**
   * 选择的标签对应的属性列表
   * @type {any[]}
   */
  public connectedClassSelected: ItemArray<any> = [];

  /**
   * 选择关联的属性
   * @type {ItemObject}
   */
  public attrSelected: ItemObject = {
    classId: 0,
    attrList: [],
  };

  /* 方法 */

  /**
   * 获取层级列表
   * @return null
   */
  public getLevelClassList(): void {
    IPSService.getAttributeList().then((res) => {
      if (isset(res, 'list')) {
        this.connectedClass = res.list;
        this.getGoodsCategoryBlackList(); // 获取网点组的商品分类黑名单
      }
    });
  }

  /**
   * 获取网点组的商品分类黑名单
   * @return null
   */
  public getGoodsCategoryBlackList(): void {
    const queryParams = {
      sgId: Number.parseInt(this.$route.params.id),
    };
    IPSService.productClassHide({ queryParams }).then((res) => {
      if (res.list) {
        this.attrSelected.attrList = res.list;
        const selected = res.list.map(item => item.attrCode); // 获取已关联分类
        const all = this.connectedClass.map(item => item.attrCode); // 所有
        this.selectConnectedClass = selected.filter((item) => {
          return all.includes(item);
        });
      }
      this.selectClassChange();
    });
  }

  /**
   * 选中的关联分类发生变化时
   */
  public selectClassChange(): void {
    const self = this;
    const selected = this.connectedClass.filter((item) => {
      // @ts-expect-error
      return self.selectConnectedClass.includes(item.attrCode);
    });

    self.connectedClassSelected = [];
    selected.forEach(
      (el) => {
        /* 查询是否被选中 */
        const attrCode = el.attrCode;
        const selected = self.attrSelected.attrList.filter((item) => {
          return item.attrCode == attrCode; // 返回已选择类
        });
        let selectValues = [];
        if (selected.length > 0) {
          const selectValueList = selected[0].attrValues.split(','); // 获取已选子分类
          const valueList = el.list.map(item => item.value_no); // 所有子分类
          selectValues = selectValueList.filter((item) => {
            return valueList.includes(item); // 返回在子分类中存在的已选择值
          });
        }
        const checkedCount = selectValues.length;
        const checkAll = checkedCount === el.list.length;
        const isIndeterminate = checkedCount > 0 && checkedCount < el.list.length;
        el = Object.assign({}, el, {
          checkAll,
          selectValues,
          isIndeterminate,
        });
        self.connectedClassSelected.push(el);
      },
    );
    self.changeAttrSelected();
  }

  /**
   * 根据选中值更改attrSelected
   */
  public changeAttrSelected(): void {
    const self = this;
    const selected = self.connectedClassSelected.filter((item) => {
      return item.selectValues.length > 0;
    });
    self.attrSelected.attrList = [];
    selected.forEach(
      (el) => {
        /* 查询是否被选中 */
        const attr = {
          attrCode: el.attrCode,
          attrName: el.attrName,
          attrValues: el.selectValues.join(','),
        };
        self.attrSelected.attrList.push(attr);
      },
    );
  }

  /**
   * 点击全选按钮
   * @param value
   */
  public onHandleCheckAllChange(value): void {
    const valueList = value.list.map(item => item.value_no); // 所有子分类
    value.selectValues = value.checkAll ? valueList : [];
    value.isIndeterminate = false;
    this.changeAttrSelected();
  }

  /**
   * 选择类型
   * @param value
   */
  public onHandleCheckedCitiesChange(value): void {
    const checkedCount = value.selectValues.length;
    value.checkAll = checkedCount === value.list.length;
    value.isIndeterminate = checkedCount > 0 && checkedCount < value.list.length;
    this.changeAttrSelected();
  }

  /**
   * 保存网点组的商品分类黑名单
   * @return null
   */
  public onSaveGoodsCategoryBlackList(): void {
    const postParams = {
      sgId: Number.parseInt(this.$route.params.id),
      list: this.attrSelected.attrList,
    };
    IPSService.saveSiteGroupProClassHide({ postParams }).then((res) => {
      if (res.ret) {
        this.$message.success('保存成功');
      } else {
        this.$message.error('保存失败');
      }
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getLevelClassList(); // 获取全部层级分类
  }
}
